module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasMultipleOffices) ? _c('div', {
    staticClass: "office-chooser center-text full-width"
  }, [_c('v-menu', {
    staticClass: "full-width",
    attrs: {
      "offset-y": "",
      "max-height": "400",
      "nudge-bottom": "0"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "office-chooser-button div-button rounded center-text full-width",
          class: _vm.buttonClass,
          style: (_vm.buttonStyle)
        }, on), [_c('div', [_c('v-icon', {
          staticStyle: {
            "color": "inherit",
            "padding-top": "3px"
          }
        }, [_vm._v("mdi-account-supervisor-circle")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex-grow": "1",
            "padding": "3px 3px 3px 6px",
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          }
        }, [_vm._v(_vm._s(_vm.currentOffice.name))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "padding": "5px 3px 3px 6px"
          }
        }, [_vm._v(_vm._s(_vm.activeCount))]), _vm._v(" "), _c('v-icon', {
          staticStyle: {
            "color": "inherit",
            "padding-top": "2px"
          }
        }, [_vm._v("arrow_drop_down")])], 1)]
      }
    }], null, false, 3530031947),
    model: {
      value: (_vm.menuVisible),
      callback: function($$v) {
        _vm.menuVisible = $$v
      },
      expression: "menuVisible"
    }
  }, [_vm._v(" "), (_vm.debugInfinite) ? _c('div') : _vm._e(), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/preferences')
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-settings")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Preferences")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.offices), function(office) {
    return _c('v-list-item', {
      key: office.meta.key,
      class: {
        'blue-hilight': _vm.isCurrentOffice(office.meta.key)
      },
      on: {
        "click": function($event) {
          return _vm.switchToOffice(office)
        }
      }
    }, [_c('v-list-item-action', [_c('v-checkbox', {
      attrs: {
        "input-value": office.active
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleOffice(office)
        }
      }
    })], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(office.name) + " (" + _vm._s(office.meta.key) + ")")]), _vm._v(" "), _c('v-list-item-icon', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey lighten-1"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.onlyOffice(office)
              }
            }
          }, on), [_vm._v("explore")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("View Only " + _vm._s(office.name))])])], 1)], 1)
  })], 2)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507ed4d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/OfficeChooser.vue
// module id = 2543
// module chunks = 1